export const RECENT_DAYS = 30;

const RECENT_WINDOW_MS = RECENT_DAYS * 24 * 60 * 60 * 1000;

const getTimestampMs = (value) => {
  if (!value) {
    return 0;
  }

  const timestamp = Date.parse(value);
  return Number.isNaN(timestamp) ? 0 : timestamp;
};

export const getLastActivityMs = (record) =>
  Math.max(getTimestampMs(record?.updatedAt), getTimestampMs(record?.createdAt));

export const isRecentlyChanged = (record, now = Date.now()) => {
  const lastActivityMs = getLastActivityMs(record);
  return lastActivityMs > 0 && lastActivityMs >= now - RECENT_WINDOW_MS;
};
